import React from 'react';

import UserLayout from '../../components/Layout/UserLayout';
import EditProfile from './EditProfile';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';

import { setSiteSettings } from '../../actions/siteSettings';
import messages from '../../locale/messages';

export default async function action({ store, params, intl }) {

  const title = intl?.formatMessage(messages.editProfile);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  await store.dispatch(setSiteSettings());

  return {
    title,
    component: <UserLayout hideMenu>
      <DashboardLayout>
        <EditProfile title={title} />
      </DashboardLayout>
    </UserLayout>,
  };
}
